import React from 'react'

export default function InactiveUser() {
    return (
        <div className='p-110 main d-flex align-items-center text-center justify-content-center flex-column'>
            <h2 className='font-weight-bold mb-3'>
                Status is Inactive and does not have permission to login.
            </h2>
        </div>
    )
}


